import { Envelope, Warning } from "@phosphor-icons/react";

// Renders a realistic-looking email for "spot the phishing" questions.
export default function EmailPreview({ email }) {
  if (!email) return null;
  return (
    <div className="rounded-xl border border-border bg-white overflow-hidden" data-testid="email-preview">
      <div className="flex items-center gap-2 px-4 py-2.5 bg-muted border-b border-border">
        <Envelope size={18} weight="duotone" className="text-primary" />
        <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">Incoming message</span>
      </div>
      <div className="p-5">
        <div className="space-y-1.5 pb-4 border-b border-dashed border-border">
          <div className="flex gap-2 text-sm">
            <span className="text-muted-foreground w-16 shrink-0">From:</span>
            <span className="font-medium text-foreground break-all">{email.sender}</span>
          </div>
          <div className="flex gap-2 text-sm">
            <span className="text-muted-foreground w-16 shrink-0">Subject:</span>
            <span className="font-semibold text-foreground">{email.subject}</span>
          </div>
        </div>
        <p className="text-foreground text-sm leading-relaxed mt-4 whitespace-pre-line">{email.body}</p>
        {email.links?.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-2">
            {email.links.map((l, i) => (
              <span
                key={i}
                className="inline-flex items-center gap-1.5 text-xs bg-accent/10 text-accent border border-accent/20 rounded-md px-2.5 py-1 break-all"
              >
                <Warning size={13} weight="fill" /> {l}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
